import Request from "../../@api/request";

const baseURL = `${process.env.REACT_APP_HOST}`;
export const request = new Request(baseURL);

export default class TractorService {
  static list = async (
    brand: string,
    search: string,
    limit: number,
    page: number,
    sort: string
  ) => {
    const result = await request.get(
      `tractor?brand=${brand}&search=${search}&limit=${limit}&page=${page}&sort=${sort}`
    );

    return result.data;
  };

  static report = async (data: any) => {
    const result = await request.post("/report/machinery-efficiency", data);
    return result.data;
  };
}
